'use strict';

/**
 * Increments a number.
 *
 * @param {Number} a The number.
 * @returns {Number} The result of `a + 1`.
 * @example
 *
 * import { inc } from 'fkit'
 * inc(1) // 2
 */
function inc(a) {
  return a + 1;
}

module.exports = inc;
